import { Box, CircularProgress } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

import Autocomplete from 'shared/components/widgets/autocomplete';
import Input from 'shared/components/widgets/input';

import Button from 'shared/components/widgets/button';
import AutocompleteContainer from 'shared/components/widgets/autocomplete-container';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const OperationHistoryFilter = ({ getFilteredList, isLoading }) => {
  const location = useLocation()
  const isRefresh = location?.state?.refresh
  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      schGroup: 'subject_filename',
      schKeyword: '',
    },
  });

  const searchTermTargetFilterData = [
    { label: '업로드 제목+ 파일명', value: 'subject_filename' },
    { label: '접속IP', value: 'remote_ip' },
  ];

  const keyword = watch('schKeyword');

  // const resetFilter = () => {
  //   reset()
  //   getFilteredList([
  //     { key: 'page', value: 1 },
  //     { key: 'schGroup', value: '' },
  //     { key: 'schKeyword', value: '' },
  //   ]);
  // }

  useEffect(() => {
    if (isRefresh) {
      setValue('schGroup', 'subject_filename')
      setValue('schKeyword', '')
    }
  }, [isRefresh])

  const onSubmit = (data) => {
    const { schGroup, schKeyword } = data;
    getFilteredList([
      { key: 'page', value: 1 },
      { key: 'schGroup', value: schGroup },
      { key: 'schKeyword', value: schKeyword },
    ]);
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      display="flex"
      flexDirection="row"
      alignItems="flex-end"
      gap={3}
      marginBottom="40px"
    >
      {/* SEARCH TERM TARGET */}
      <AutocompleteContainer>
        <Controller
          name="schGroup"
          control={control}
          render={({ field }) => {
            return (
              <Autocomplete
                {...field}
                title="검색어 대상"
                options={searchTermTargetFilterData}
                defaultValue={
                  searchTermTargetFilterData.find(
                    (el) => el.value === field.value,
                  ) ?? { label: '업로드 제목', value: 'subject_filename' }
                }
                value={field?.value ?? 'subject_filename'}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                onChange={(_, newValue, reason) => {
                  field.onChange(newValue?.value);
                  if (reason === 'clear') {
                    field.onChange('subject_filename');
                  }
                }}
              />
            );
          }}
        />
      </AutocompleteContainer>
      {/* SEARCH */}
      <Box flex={1}>
        <Controller
          name="schKeyword"
          control={control}
          render={({ field }) => {
            return (
              <Input
                {...field}
                keyword={keyword}
                isSearch
                placeholder="검색어를 입력해 주세요."
                clearAction={() => {
                  field.onChange('')
                }}
                value={field.value}
                showErrorMsg={false}
              />
            );
          }}
        />
      </Box>
      <Button
        disabled={isLoading}
        variant="outlined"
        type="submit">
        {isLoading
          ? <CircularProgress size={20} color='secondary' />
          : '검색하기'}
      </Button>
    </Box>
  );
};

export default OperationHistoryFilter;
